import React, { useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  BRAND_COLOR,
  BRAND_HOVER,
  PAGE_PORTAL_ORDERS_INVOICES_LIST,
  PORTAL_PREFIX,
  KivuI18nContext,
  localizedPath,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";

const NoInvoiceDetailFound: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useKivunovaTranslation();
  const { language, defaultLang } = useContext(KivuI18nContext) || {};

  const handleBackToList = () => {
    navigate(
      localizedPath(
        `/${PORTAL_PREFIX}/${PAGE_PORTAL_ORDERS_INVOICES_LIST}`,
        language,
        defaultLang
      )
    );
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      gap={3}
    >
      <Typography variant="h6" color="text.primary" fontWeight="bold">
        {t("invoice-not-found", "Invoice not found")}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t(
          "invoice-not-found-description",
          "The invoice you're looking for doesn't exist or has been removed."
        )}
      </Typography>
      <Box>
        <Button
          variant="contained"
          onClick={handleBackToList}
          sx={{
            backgroundColor: BRAND_COLOR,
            "&:hover": { backgroundColor: BRAND_HOVER },
            textTransform: "none"
          }}
        >
          {t("back-to-invoice-list", "Back to Invoice List")}
        </Button>
      </Box>
    </Box>
  );
};

export default NoInvoiceDetailFound;
